import {Component, EventEmitter, Input, Output, OnChanges, SimpleChanges, OnInit} from '@angular/core';
import {SalesConciergeCustomContactInfo, SalesConciergeRequest} from '../../../models/sales-concierge-request.model';
import {SalesConciergeContactType} from '../../../enums/sales-concierge-contact-type.enum';
import {SalesConciergeStep} from '../../../enums/sales-concierge-step.enum';
import {SalesConciergeRequestType} from '../../../enums/sales-concierge-request-type.enum';
import {SalesConciergeProductCount} from '../../../enums/sales-concierge-product-count.enum';


@Component({
    selector: 'sales-concierge-customer-contact-info.',
    templateUrl: './customer-contact-info.component.html',
    styleUrls: ['./customer-contact-info.component.scss']
})
export class SalesConciergeCustomerContactInfoComponent implements OnChanges, OnInit {


    public showCustomerInfo = false;


    @Input() public salesConciergeRequest: SalesConciergeRequest;
    public salesConciergeContactType = SalesConciergeContactType;

    @Input() reset = false;
    @Output() salesConciergeStep = new EventEmitter<SalesConciergeStep>();
    @Output() salesConciergeNextStep = new EventEmitter<SalesConciergeStep>();
    @Output() isDataValid = new EventEmitter<boolean>();
    @Output()
    public selectedSalesConciergeRequest: EventEmitter<SalesConciergeRequest> = new EventEmitter<SalesConciergeRequest>();


    public selectedContactType: string;


    public constructor() {


    }


    public ngOnInit() {
        this.salesConciergeNextStep.emit(SalesConciergeStep.SEND_REQUEST);
    }

    public onPreviousBtnClicked() {

        this.salesConciergeNextStep.emit(SalesConciergeStep.CUSTOMER_CONTACT_INFO);

        switch (SalesConciergeRequestType[this.salesConciergeRequest.requestType]) {
            case SalesConciergeRequestType.DEALER_CONTRACT_OR_BILLING_ISSUES:
                this.salesConciergeStep.emit(SalesConciergeStep.REQUEST_TYPE);
                break;
            case SalesConciergeRequestType.OTHER_ISSUES:
                this.salesConciergeStep.emit(SalesConciergeStep.REQUEST_TYPE);
                break;
            case SalesConciergeRequestType.TECHNICAL_ISSUE_OR_SUPPORT:
                this.salesConciergeStep.emit(SalesConciergeStep.REQUEST_TYPE);
                break;
            case SalesConciergeRequestType.NEW_ACQUISITION:
                if (SalesConciergeProductCount[this.salesConciergeRequest.productCountInfo] === SalesConciergeProductCount.MORE_THAN_50) {
                    this.salesConciergeStep.emit(SalesConciergeStep.CUSTOMER_INFO);
                }

                if (SalesConciergeProductCount[this.salesConciergeRequest.productCountInfo] === SalesConciergeProductCount.NO_INFORMATION) {
                    this.salesConciergeStep.emit(SalesConciergeStep.PRODUCT_COUNT_INFO);
                }

                if (SalesConciergeProductCount[this.salesConciergeRequest.productCountInfo] === SalesConciergeProductCount.LESS_THAN_50) {
                    this.salesConciergeStep.emit(SalesConciergeStep.PRODUCT_COUNT_INFO);
                }

                break;
            case SalesConciergeRequestType.NO_INFORMATION:
                this.salesConciergeStep.emit(SalesConciergeStep.REQUEST_TYPE);
                break;
        }


    }

    public ngOnChanges(change: SimpleChanges) {


        this.salesConciergeNextStep.emit(SalesConciergeStep.SEND_REQUEST);
        if (change['reset'] && change['reset'].currentValue) {

            this.selectedContactType = this.salesConciergeRequest.contactType;
            this.showCustomerInfo = false;
        }

    }


    public getKeyByValue(EnumType: Object, value: any): string {
        return Object.keys(EnumType).find(key => EnumType[key] === value);
    }


    public setCustomerContactType(type: string) {

        const key = this.getKeyByValue(SalesConciergeContactType, type);
        this.salesConciergeRequest.contactType = key;
        this.selectedContactType = key;
        this.selectedSalesConciergeRequest.emit(this.salesConciergeRequest);

        if (SalesConciergeContactType[key] === SalesConciergeContactType.CUSTOM_CONTACT_INFO) {
            this.showCustomerInfo = true;

            if (this.salesConciergeRequest.customContactInfo === null) {
                this.salesConciergeRequest.customContactInfo = new SalesConciergeCustomContactInfo();
                this.salesConciergeRequest.customContactInfo.name = null;
                this.salesConciergeRequest.customContactInfo.phone = null;
                this.salesConciergeRequest.customContactInfo.email = null;
            }

        } else {
            this.showCustomerInfo = false;

        }


    }

    public setCustomerContactInfoEmail(email: string) {


        this.salesConciergeRequest.customContactInfo.email = email;
        this.selectedSalesConciergeRequest.emit(this.salesConciergeRequest);


    }

    public setRequestNotes(notes: string) {


        this.salesConciergeRequest.requestNotes = notes;
        this.selectedSalesConciergeRequest.emit(this.salesConciergeRequest);


    }


    public setCustomerContactInfoName(name: string) {


        this.salesConciergeRequest.customContactInfo.name = name;
        this.selectedSalesConciergeRequest.emit(this.salesConciergeRequest);


    }

    public setCustomerContactInfoPhone(phone: number) {


        this.salesConciergeRequest.customContactInfo.phone = phone;
        this.selectedSalesConciergeRequest.emit(this.salesConciergeRequest);


    }

}
